import { Navigate, useLocation } from 'react-router-dom'
import { useGetCurrentUserQuery } from '@/entities/user'
import { Loader } from '@/shared/ui' // or any spinner/loading component you use

export const IsOwner = ({ children }: { children: JSX.Element }) => {
	const { data: currentUser, isLoading: isUserLoading } =
		useGetCurrentUserQuery()

	const location = useLocation()

	// Wait until both queries are fully loaded
	if (isUserLoading) {
		return <Loader />
	}

	// Guard logic
	const hasAccess = currentUser?.role?.name === 'Owner'

	if (!hasAccess) {
		return <Navigate to='/' state={{ from: location }} replace />
	}

	return children
}
